/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiEmployeesMutationRequest,
  PostApiEmployeesMutationResponse,
} from '../models/PostApiEmployees.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiEmployeesMutationResponseSchema,
  postApiEmployeesMutationRequestSchema,
} from '../zod/postApiEmployeesSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiEmployeesMutationKey = () =>
  [{ url: '/api/employees' }] as const;

export type PostApiEmployeesMutationKey = ReturnType<
  typeof postApiEmployeesMutationKey
>;

/**
 * {@link /api/employees}
 */
export async function postApiEmployees(
  data: PostApiEmployeesMutationRequest,
  config: Partial<RequestConfig<PostApiEmployeesMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiEmployeesMutationRequestSchema.parse(data);
  const res = await request<
    PostApiEmployeesMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiEmployeesMutationRequest
  >({
    method: 'POST',
    url: `/api/employees`,
    data: requestData,
    ...requestConfig,
  });
  return postApiEmployeesMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/employees}
 */
export function usePostApiEmployees<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiEmployeesMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiEmployeesMutationRequest },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig<PostApiEmployeesMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiEmployeesMutationKey();

  return useMutation<
    PostApiEmployeesMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiEmployeesMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiEmployees(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
